module.exports = __webpack_public_path__ + "static/media/CV.10bc0622.svg";